import React from "react"
import PropTypes from "prop-types"
import classnames from 'classnames/bind'

import LoadingBlock from "js/components/shared/LoadingBlock"

import styles from './Loader.module.scss'

const cx = classnames.bind(styles)

const Loader = ({ className }) => (
  <div className={cx("root", className)}>
    <div className={cx('title')}>
      <LoadingBlock style={{display: "inline-block", height: "26px"}}/>
    </div>
    <ul className={cx('items')}>
      <li className={cx('item')}>
        <LoadingBlock style={{display: "inline-block", width: '50%', height: "28px"}}/>
      </li>
      <li className={cx('item')}>
        <LoadingBlock style={{display: "inline-block", width: '75%', height: "28px"}}/>
      </li>
      <li className={cx('item')}>
        <LoadingBlock style={{display: "inline-block", width: '60%', height: "28px"}}/>
      </li>
      <li className={cx('item')}>
        <LoadingBlock style={{display: "inline-block", width: '50%', height: "28px"}}/>
      </li>
      <li className={cx('item')}>
        <LoadingBlock style={{display: "inline-block", width: '70%', height: "28px"}}/>
      </li>
    </ul>
  </div>
)

Loader.propTypes = {
  className: PropTypes.string
}

export default Loader
